import { get, set } from 'quartz/globalState/api';
import { getHstc } from 'usage-tracker-core/common/defaultTrackers';
import { isHubSpotDomain } from 'usage-tracker-core/client/browserHelper';
import { TRACKING_CONTEXT } from './state/globalState';
import { INTERNAL_TRACKING_CONTEXT } from './state/internalState';
import { getBaseTrackingClient } from './clients/base';
import { getAnonymousTrackingClient } from './clients/anonymous';
import { createHstcScheduler } from './utils';
import { ALLOWED_UNAUTHED_TYPES } from './constants';
const getClientType = (auth, hstc) => auth === 'none' && !hstc ? 'anonymous' : 'base';
const createClient = (auth, trackerProperties) => getClientType(auth, trackerProperties.hstc) === 'base' ? getBaseTrackingClient(trackerProperties) : getAnonymousTrackingClient(trackerProperties);

// For auth "none", the tracker must be switched when HSTC changes
// (e.g. cookie banner acceptance or UTK becoming available/unavailable)
const startHstcWatcher = (auth, trackerProperties, initialClient, onSwitch) => {
  let currentHstc = trackerProperties.hstc;
  let currentClientType = getClientType(auth, currentHstc);
  const clientCache = {
    [currentClientType]: initialClient
  };
  return createHstcScheduler({
    getHstc,
    interval: 200,
    callback: newHstc => {
      if (newHstc !== currentHstc) {
        currentHstc = newHstc;
        const nextType = getClientType(auth, newHstc);
        if (nextType !== currentClientType) {
          var _clientCache$nextType;
          currentClientType = nextType;
          (_clientCache$nextType = clientCache[nextType]) !== null && _clientCache$nextType !== void 0 ? _clientCache$nextType : clientCache[nextType] = createClient(auth, Object.assign({}, trackerProperties, {
            hstc: newHstc
          }));
          onSwitch(clientCache[nextType]);
        }
      }
    }
  });
};
export function initializeTracking({
  config: {
    auth,
    tracking
  },
  trackerProperties
}) {
  const listeners = new Set();
  let currentIntervalNumber;
  const onTrackerSwitch = callback => {
    listeners.add(callback);
  };
  const createAndSetTracker = client => {
    listeners.forEach(cb => cb());
    const {
      track
    } = client.createTracker({
      standalone: true,
      isExternalHost: auth === 'none' && !isHubSpotDomain,
      allowUnauthed: ALLOWED_UNAUTHED_TYPES.includes(auth),
      trackerName: tracking === null || tracking === void 0 ? void 0 : tracking.trackerName,
      properties: {
        deviceId: client.getDeviceId()
      }
    });
    set(TRACKING_CONTEXT, {
      track,
      onTrackerSwitch
    });
  };
  const existingInternalState = get(INTERNAL_TRACKING_CONTEXT);
  if (existingInternalState !== undefined) {
    existingInternalState.dispose();
  }
  const initialClient = createClient(auth, trackerProperties);
  createAndSetTracker(initialClient);
  if (auth === 'none') {
    currentIntervalNumber = startHstcWatcher(auth, trackerProperties, initialClient, createAndSetTracker);
  }
  const disposeTracking = () => {
    clearInterval(currentIntervalNumber);
    listeners.forEach(listener => listeners.delete(listener));
    set(TRACKING_CONTEXT, {
      track: () => {},
      onTrackerSwitch: () => {}
    });
  };
  set(INTERNAL_TRACKING_CONTEXT, {
    dispose: disposeTracking
  });
}